import type { SVGProps } from "react";
import { Ref, forwardRef, memo } from "react";
import { useId } from "react";
/**
 * Can be sized by setting height only
 */
const SvgComponent = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => {
  // Dynamic mask id, sometimes required
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const id = useId();
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={undefined}
      height={18}
      fill="none"
      viewBox="0 0 18 18"
      aria-hidden="true"
      focusable="false"
      ref={ref}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M9 18A9 9 0 1 0 9 0a9 9 0 0 0 0 18m3.765-11.634L10.131 9l2.634 2.634a.8.8 0 1 1-1.13 1.132L9 10.13l-2.634 2.635a.8.8 0 0 1-1.131 0 .8.8 0 0 1 0-1.132L7.869 9 5.235 6.366a.8.8 0 1 1 1.13-1.131L9 7.869l2.634-2.634a.799.799 0 1 1 1.131 1.13"
        clipRule="evenodd"
      />
    </svg>
  );
};
const ForwardRef = forwardRef(SvgComponent);
const Memo = memo(ForwardRef);
export default Memo;
